module.exports = __webpack_public_path__ + "src/assets/textures/molar/spoon0_1.jpg";